import React, { useState, useEffect } from 'react';
import { Button, Icon, Modal, List, ListHeader } from 'semantic-ui-react';

const BarraSempliceMobile = ({ categorieArticoli, infoNegozio }) => {
  const [openCategorie, setOpenCategorie] = useState(false);
  const [openContatti, setOpenContatti] = useState(false);
  const [closing, setClosing] = useState(false);

  const handleClickCategoria = () => setOpenCategorie(true);
  const handleClickContatti = () => setOpenContatti(true);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setOpenCategorie(false);
      setOpenContatti(false);
      setClosing(false);
    }, 150);
  };

  const handleScrollToCategoria = (categoria) => {
    const elmnt = document.getElementById("categoria-" + categoria);
    if (elmnt) {
      elmnt.scrollIntoView({ behavior: 'smooth' });
    }
    handleClose();
  };

  const handleScrollToUlterioriInfo = (categria) => {
    const elmnt = document.getElementById("ulteriori-info");
    if (elmnt) {
      elmnt.scrollIntoView({ behavior: 'smooth' });
    }
    handleClose();
  };

  return (
    <>
      {/* Barra fissa in basso */}
      <div className="flex dn-l"
        style={{
          position: 'fixed',
          paddingLeft: '1rem',
          paddingRight: '1rem',
          bottom: 0,
          width: '100%',
          justifyContent: 'space-around',
          background: '#fff',
          borderTop: '2px solid #fbd10d',
          boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
          zIndex: 1000,
        }}
      >
        <Button
          icon
          labelPosition="left"
          onClick={handleClickCategoria}
          style={{ flex: 1, borderRadius: 0, background: '#fff' }}
        >
          <Icon name="list" />
          Categorie
        </Button>
        <Button
          icon
          labelPosition="left"
          onClick={handleClickContatti}
          style={{ flex: 1, borderRadius: 0, background: '#fff' }}
        >
          <Icon name="phone" />
          Info
        </Button>
      </div>

      {/* Modal Categorie */}
      <Modal
        id="modal-categorie"
        dimmer={false}
        open={openCategorie}
        onClose={handleClose}
        className={closing ? 'slide-out' : ''}
        style={{
          position: 'fixed',
          bottom: 0,
          margin: 0,
          width: '100%',
          height: '60%',
          borderRadius: '1rem 1rem 0 0',
          overflow: 'hidden',
          animation: closing ? 'slide-out-bottom 0.15s forwards' : 'slide-in-bottom 0.15s ease-in-out',
          background: '#fff',
        }}
        closeIcon
      >
        <Modal.Header>Seleziona una Categoria</Modal.Header>
        <Modal.Content scrolling>
          <List selection divided relaxed style={{ paddingBottom: '150px' }}>
            {categorieArticoli.map((categoria) => (
              <List.Item
                key={categoria.id}
                onClick={() => handleScrollToCategoria(categoria.nome)}
                style={{
                  cursor: 'pointer',
                  fontSize: '1.2rem',
                  color: '#000',
                  fontWeight: '500',
                }}
              >
                {categoria.nome}
              </List.Item>
            ))}
          </List>
        </Modal.Content>
      </Modal>

      {/* Modal Contatti */}
      <Modal
        id="modal-contatti"
        dimmer={false}
        open={openContatti}
        onClose={handleClose}
        className={closing ? 'slide-out' : ''}
        style={{
          position: 'fixed',
          bottom: 0,
          margin: 0,
          width: '100%',
          height: '60%',
          borderRadius: '1rem 1rem 0 0',
          overflow: 'hidden',
          animation: closing ? 'slide-out-bottom 0.15s forwards' : 'slide-in-bottom 0.15s ease-in-out',
          background: '#fff',
        }}
        closeIcon
      >
        <Modal.Header>Info e Contatti</Modal.Header>
        <Modal.Content scrolling>
          <List relaxed divided>
            <List.Item style={{ fontSize: '1.2rem', color: '#000', fontWeight: '500' }}>
              <Icon name="phone" color="green" />
              <List.Content>
                <a href={`tel:+39${infoNegozio.telefono}`} style={{ color: '#000' }}>+39 {infoNegozio.telefono}</a>
              </List.Content>
            </List.Item>
            <List.Item style={{ fontSize: '1.2rem', color: '#000', fontWeight: '500' }}>
              <Icon name="whatsapp" color="green" />
              <List.Content>
                <a href={`https://wa.me/39${infoNegozio.telefono}`} target="_blank" rel="noreferrer" style={{ color: '#000' }}>
                  Chatta su WhatsApp
                </a>
              </List.Content>
            </List.Item>
            <List.Item style={{ fontSize: '1.2rem', color: '#000', fontWeight: '500' }}>
              <Icon name="mail" color="blue" />
              <List.Content>
                <a href={`mailto:${infoNegozio.email}`} style={{ color: '#000' }}>{infoNegozio.email}</a>
              </List.Content>
            </List.Item>
            <List.Item style={{ fontSize: '1.2rem', color: '#000', fontWeight: '500' }}>
              <Icon name="map marker alternate" color="red" />
              <List.Content>
                <a href={infoNegozio.indirizzo_maps} target="_blank" rel="noreferrer" style={{ color: '#000' }}>
                  <ListHeader>Visualizza su Google Maps</ListHeader>
                  {infoNegozio.via}, {infoNegozio.cap} {infoNegozio.citta} {infoNegozio.provincia}
                </a>
              </List.Content>
            </List.Item>
            {infoNegozio.ulteriori_info && (
              <List.Item
                style={{ fontSize: '1.2rem', color: '#000', fontWeight: '500' }}
                onClick={() => handleScrollToUlterioriInfo()}
              >
                <Icon name="info" color="blue" />
                Ulteriori Info
              </List.Item>
            )}
          </List>
        </Modal.Content>
      </Modal>

      {/* CSS Animazioni */}
      <style>{`
        @keyframes slide-in-bottom {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes slide-out-bottom {
          from { transform: translateY(0); opacity: 1; }
          to { transform: translateY(100%); opacity: 0; }
        }
        .slide-out {
          animation: slide-out-bottom 0.15s forwards;
        }

        .ui.dimmer {
            background-color: rgba(0, 0, 0, 0.85);
            transition: background-color 0.3s ease-in-out !important;
        }
      `}</style>
    </>
  );
};

export default BarraSempliceMobile;

